// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BankAPIModel,
    BankAPIModelFromJSON,
    BankAPIModelFromJSONTyped,
    BankAPIModelToJSON,
    TimingAPIModel,
    TimingAPIModelFromJSON,
    TimingAPIModelFromJSONTyped,
    TimingAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface DiscoveredBanksAPIModel
 */
export interface DiscoveredBanksAPIModel {
    /**
     * 
     * @type {string}
     * @memberof DiscoveredBanksAPIModel
     */
    messageId: string;
    /**
     * 
     * @type {Array<BankAPIModel>}
     * @memberof DiscoveredBanksAPIModel
     */
    banks?: Array<BankAPIModel>;
    /**
     * 
     * @type {TimingAPIModel}
     * @memberof DiscoveredBanksAPIModel
     */
    timing: TimingAPIModel;
}

export function DiscoveredBanksAPIModelFromJSON(json: any): DiscoveredBanksAPIModel {
    return DiscoveredBanksAPIModelFromJSONTyped(json, false);
}

export function DiscoveredBanksAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscoveredBanksAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
        'banks': !exists(json, 'banks') ? undefined : ((json['banks'] as Array<any>).map(BankAPIModelFromJSON)),
        'timing': TimingAPIModelFromJSON(json['timing']),
    };
}

export function DiscoveredBanksAPIModelToJSON(value?: DiscoveredBanksAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messageId': value.messageId,
        'banks': value.banks === undefined ? undefined : ((value.banks as Array<any>).map(BankAPIModelToJSON)),
        'timing': TimingAPIModelToJSON(value.timing),
    };
}


